/* eslint-disable @typescript-eslint/prefer-includes */
export function isIOS(): boolean {
  return navigator.userAgent.match(/(iPhone)|(iPod)/i) !== null;
}

export function isFirefox(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('firefox');
}

export function isSafari(): boolean {
  return Boolean(
    navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1
  );
}
